import { useAlert } from '@/contexts/Toast'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

export function useInternetConnection() {
  const { alert } = useAlert()
  const { t } = useTranslation()

  useEffect(() => {
    const onOffline = () => {
      alert(t('lost-connection'), 'error')
    }

    window.addEventListener('offline', onOffline)
    return () => window.removeEventListener('offline', onOffline)
  }, [])
}
